<template>
  <div class="isolated">
    <div class="tb-checkbox">
      <input type="checkbox" id="interactiveBox" v-on:change="setField('interactive', $event.target.checked)" :checked="getField('interactive')" data-test="displays-editors-showCTA">
      <label for="interactiveBox">Interactive</label>
    </div>

    <cta
      :item="item"
      :theme="theme"
      :editing="editing"
    />

    <animation v-model="animation" />

    <div class="tb-form-group">
      <label class="tb-label">Cycle speed</label>

      <input
        type="number"
        class="tb-input"
        :value="getNiceTime(getField('displayTime'))"
        data-entity="producer-editor-displayTime"
        data-test="display-editor-cycleSpeed"
        @keyup.right.stop
        @keyup.left.stop
        @change="setNiceTime('displayTime', $event.target.value)"
      >

      <span class="help-text">Range: 1 - 100 seconds</span>
    </div>

    <background
      :item="item"
      :theme="theme"
      :editing="editing"
    />

    <!-- QR Code -->
    <p class="tb-label">QR Code</p>
    <div class="tb-checkbox" data-entity="producer-editor-toggleQRCode">
      <input type="checkbox" id="showQrCode" v-model="showQrCode">
      <label for="showQrCode">Show</label>
    </div>

    <template v-if="showQrCode">
      <!-- eslint-disable vue/no-v-model-argument -->
      <qr-code-url v-model:url="permalink" v-model:short-url="shortLink"
        v-model:tracking-link-rid="trackingLinkRid" v-model:tracking-link-metadata-rid="trackingLinkMetadataRid"
        v-model:product-info="qrProductInfo" :item="item"
        :element="theme" :entity-id="theme._id" />
      <!-- eslint-enable vue/no-v-model-argument -->

      <div class="tb-form-group mt-4 flex items-center">
        <label class="tb-label mb-0 mr-2">Background Color</label>

        <colorpicker :color="themeFields.qrCodeBackgroundColor"
          data-entity="producer-editor-toggleQRCodeBackgroundColorPicker"
          :large="true"
          @change="setField('qrCodeBackgroundColor', $event)" />
      </div>

      <div class="tb-form-group flex items-center">
        <label class="tb-label mb-0 mr-2">Dot Color</label>

        <colorpicker :color="themeFields.qrCodeDotColor" data-entity="producer-editor-toggleQRCodeDotColorPicker"
          :large="true"
          @change="setField('qrCodeDotColor', $event)" />
      </div>

      <div class="tb-form-group">
        <div class="tb-checkbox">
          <input type="checkbox" id="showQrCodeLogo" v-model="showQrCodeLogo"
            data-entity="producer-editor-toggleImageLogo"
            @change="$emit('value', { value: $event.target.checked, field: 'showQrCodeLogo' })" />

          <label for="showQrCodeLogo">Show image logo</label>
        </div>
      </div>

      <template v-if="showQrCodeLogo">
        <div class="tb-form-group">
          <div v-if="getField('qrCodeLogo')" class="media-upload-wrapper">
            <div class="media" :style="{ 'background-image': 'url(' + getField('qrCodeLogo') + ')' }"></div>
            <div class="edit-media">
              <button class="tb-btn tb-btn-contained on-image" data-entity="producer-editor-editLogo"
                @click="selectAsset">
                <span class="fas fa-pencil-alt" />
              </button>

              <button class="tb-btn tb-btn-contained on-image" data-entity="producer-editor-clearBackgroundImage"
                @click="setField('qrCodeLogo', '')">
                <span class="fas fa-times" />
              </button>
            </div>
          </div>

          <button v-else class="tb-btn tb-btn-contained medium-em" data-entity="producer-editor-selectLogo"
            @click="selectAsset">
            <span class="fas fa-image mr-1"></span>
            Choose image
          </button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import editingMixins from '../../../mixins/editing-mixins';

import Cta from '../shared/Cta.vue';
import Background from '../shared/Background.vue';
import Animation from '../shared/Animation.vue';
import QrCodeUrl from '../../shared/QrCodeUrl.vue';

export default {
  mixins: [editingMixins],

  components: {
    Cta,
    Background,
    Animation,
    QrCodeUrl,
  },

  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },
  computed: {
    showQrCode: {
      get() {
        return this.themeFields.showQrCode;
      },

      set(v) {
        this.setField('showQrCode', v);
      },
    },

    showQrCodeLogo: {
      get() {
        return this.themeFields.showQrCodeLogo;
      },

      set(v) {
        this.setField('showQrCodeLogo', v);
      },
    },

    qrCodeLogo: {
      get() {
        return this.themeFields.qrCodeLogo;
      },

      set(v) {
        this.setField('qrCodeLogo', v);
      },
    },

    permalink: {
      get() {
        return this.themeFields.permalink;
      },

      set(v) {
        this.setField('permalink', v);
      },
    },

    shortLink: {
      get() {
        return this.themeFields.shortLink ?? '';
      },
      set(v) {
        this.setField('shortLink', v);
      },
    },

    trackingLinkRid: {
      get() {
        return this.themeFields.trackingLinkRid ?? '';
      },
      set(v) {
        this.setField('trackingLinkRid', v);
      },
    },

    trackingLinkMetadataRid: {
      get() {
        return this.themeFields.trackingLinkMetadataRid ?? '';
      },
      set(v) {
        this.setField('trackingLinkMetadataRid', v);
      },
    },

    qrProductInfo: {
      get() {
        return this.themeFields.qrProductInfo ?? {};
      },
      set(v) {
        this.setField('qrProductInfo', v);
      },
    },
  },

  methods: {
    selectAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'image' });

      window.assetmanfn = (asset, meta = {}) => {
        this.setField('qrCodeLogo', asset.media_url);
        this.setField('qrCodeLogoMeta', meta);
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'image' });
      };
    },
  },
};
</script>
